import { storefrontZipcodeServicesHttpClient } from '@src/quince-site-common/src/utils/HttpClient'
import { ANALYTIC_COOKIES } from '@src/quince-site-common/src/utils/constants'
import setCookie from '@src/quince-site-common/src/utils/setCookie'
import getCookie from '@src/quince-site-common/src/utils/getCookie'
import { captureFatalException } from '@src/quince-site-common/src/utils/sentryUtil'
import { FEATURES, MODULES } from '@src/quince-site-common/src/constants/template-info'

let ipAddressPromise: Promise<string | null> | null = null

export const fetchIpAddress = async () => {
  try {
    const res = await storefrontZipcodeServicesHttpClient.get<{ body: { ipAddress: string } }>('/get-ip-address')
    const ipVal = res.data?.body?.ipAddress || null
    if (ipVal) {
      setCookie(ANALYTIC_COOKIES.ECOMM_IP, ipVal)
    }
    return ipVal
  } catch (error) {
    captureFatalException('Failed while fetching user agent using getIpAddress() runtime, API - /get-ip-address', {
      module: MODULES.BROWSER_INFO,
      feature: FEATURES.IP_ADDRESS,
      extraInfo: error,
    })
  }
  return null
}

export async function getIpAddress(): Promise<string | null> {
  const ipAddress = getCookie(ANALYTIC_COOKIES.ECOMM_IP) || null
  if (ipAddress) {
    return ipAddress
  }

  if (!ipAddressPromise) {
    ipAddressPromise = fetchIpAddress().finally(() => {
      resetIpAddressPromise()
    })
  }

  return await ipAddressPromise
}

export async function getUserIp() {
  return await getIpAddress()
}

const resetIpAddressPromise = () => {
  ipAddressPromise = null
}
